package app.smartcoding.realrate.domain.model

data class EvaluationResult(
    val rating: CreditRating,
    val summary: String,
    val details: String,
    val score: Double
)
